import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TypeaheadContext = /*#__PURE__*/createContext(undefined);
export const TypeaheadProvider = ({
  typeaheadResultsStyleOverrides,
  typeaheadResultsGroupStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    typeaheadResultsStyleOverrides,
    typeaheadResultsGroupStyleOverrides
  }), [typeaheadResultsStyleOverrides, typeaheadResultsGroupStyleOverrides]);
  return /*#__PURE__*/_jsx(TypeaheadContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Typeahead` component.
 * Note: The context is only available when the `Typeahead` component is rendered as an ancestor.
 * @returns TypeaheadContext - The context for the `Typeahead` component.
 * @returns TypeaheadContext.typeaheadResultsStyleOverrides - Style overrides to be applied to the `TypeaheadResults` component.
 * @returns TypeaheadContext.typeaheadResultsGroupStyleOverrides - Style overrides to be applied to the `TypeaheadResultsGroup` component.
 */
export const useTypeaheadContext = () => {
  const typeaheadContext = useContext(TypeaheadContext);
  return typeaheadContext;
};